import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FlatButtonComponent } from './flat-button.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FlatButtonComponent],
  exports: [FlatButtonComponent],
})
export class FlatButtonModule {}
